import React from 'react';
import PropTypes from 'prop-types';
import { AccordionItem } from './AccordionItem';
import * as S from './styled';

export const AccordionGroup = ({ title, items, id }) => {
  return (
    <S.AccordionContainer key={id}>
      <S.AccordionGroupTitle>{title}</S.AccordionGroupTitle>
      {items.map((item) => {
        return <AccordionItem item={item} key={item.subject} />;
      })}
    </S.AccordionContainer>
  );
};

AccordionGroup.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      subject: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      expanded: PropTypes.bool,
    })
  ).isRequired,
};
